import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBox2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBox2"><Path d="M21 21H3L3.00003 14H7.41605C8.1876 15.7659 9.94968 17 12 17C14.0503 17 15.8124 15.7659 16.584 14L21 14L21 21Z" fill="currentColor"/><Path d="M21 12L21 3L3.00006 3.00001L3.00003 12H9.00001V12.0064C9.00346 13.6603 10.3453 15 12 15C13.6569 15 15 13.6569 15 12L21 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBox2;
